import React from 'react';

import { getRecentSearches, RECENT_SEARCH_KEY } from '@atlassian/dynamic-cards-search-common';

import { type PrimaryProductKey } from '../../../common/constants/products';
import { type SearchLinkProps } from '../../../common/ui/search-link';
import { filterSearchResults } from '../../../common/utils/filter-search-results';

export const prefetchRecentSearchResults = (
	primaryProduct?: PrimaryProductKey,
	userId?: string | null,
) => {
	if (userId && primaryProduct) {
		const recentSearches = getRecentSearches(userId, primaryProduct, RECENT_SEARCH_KEY).map(
			(searchTitle) => ({
				title: searchTitle,
				icon: <></>,
				onClick: () => null,
			}),
		);

		return recentSearches;
	}
	return [];
};

export const filterRecentSearchResults = (
	recentSearches: SearchLinkProps[],
	inputQuery: string,
) => {
	if (inputQuery.length === 0) {
		return recentSearches;
	}
	return filterSearchResults(recentSearches, inputQuery, inputQuery.length < 3 ? 3 : 2, true);
};
